var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DataLineGraph component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDataLineGraph extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.60449 1.85498C2.60449 1.44077 2.26871 1.10498 1.85449 1.10498C1.44028 1.10498 1.10449 1.44077 1.10449 1.85498V22.145C1.10449 22.5592 1.44028 22.895 1.85449 22.895H22.1445C22.5587 22.895 22.8945 22.5592 22.8945 22.145C22.8945 21.7308 22.5587 21.395 22.1445 21.395H2.60449V1.85498ZM16.2074 5.14654C16.0421 5.02849 15.836 4.98251 15.6363 5.01913C15.4365 5.05574 15.2601 5.17182 15.1474 5.34081L9.41182 13.9442L6.1568 10.6892C5.8639 10.3963 5.38903 10.3963 5.09613 10.6892C4.80324 10.9821 4.80324 11.457 5.09613 11.7499L8.99806 15.6518C9.15694 15.8107 9.37869 15.8899 9.60229 15.8678C9.82589 15.8457 10.0278 15.7244 10.1524 15.5375L15.9658 6.81736L20.7982 10.2691C21.1353 10.5098 21.6037 10.4318 21.8445 10.0947C22.0852 9.75763 22.0071 9.28922 21.6701 9.04846L16.2074 5.14654Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDataLineGraph.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDataLineGraph.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDataLineGraph.prototype, "size", void 0);
if (customElements.get('cat-icon-data-line-graph') === undefined) {
    customElements.define('cat-icon-data-line-graph', BlocksIconDataLineGraph);
}
